// extracted by mini-css-extract-plugin
module.exports =  {"item":"a10a3f92e9--item--Iy1FT","logo":"a10a3f92e9--logo--e0PEF"};